import axios from "axios";

import { to,toLocal } from "../../helpers/api.helper";

export const landWars = {
    setupAttack: ({ attackerLandID, defenderLandID }) => {
        return axios.post(to("land-wars/attack"), { attackerLandID, defenderLandID });
    },
};
